import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function DatePickerField({
  label = 'Select date',
  value, // should be a moment object or null
  onChange, // receives a moment or null
  error,
  helperText,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        label={label}
        value={value}
        onChange={onChange}
        disablePast
        format="DD/MM/YYYY"
        slotProps={{
          textField: {
            fullWidth: true,
            error: Boolean(error),
            helperText,
            onKeyDown: (e) => e.preventDefault(), // disable manual typing
          },
        }}
      />
    </LocalizationProvider>
  );
}
